import useShallowEqualSelector from '../../../custom_hooks/useShallowEqualsSelector';
import { ReducerKeys } from '../../../redux/reducers';
import { StateStatus } from '../../utils/common';
import { useSelector } from 'react-redux';

interface MessageIncomingListElement {
  message_incoming_id: number;
  lxr_ccn_id: string;
  application_type: string;
  file_name: string;
  // message_text: string;
  message_file: string;
  message_type: string;
  originating_country: string;
  destination_country: string;
  message_id: string;
  correlation_id: string;
  ccncsi_correlation_id: string;
  sent_flag: number;
  read_flag: number;
  message_ref_id: number;
  transmision_date: Date;
  created_by: string;
  created_at: Date;
  modified_by: string;
  modified_at: Date;
}

interface MessageIncomingListData {
  paging: Paging;
  items: MessageIncomingListElement[];
}

interface Paging {
  page: number;
  pageSize: number;
  total: number;
}

interface MessageIncomingListOutput {
  status: StateStatus;
  data: MessageIncomingListData | null;
}

export const useGetMessageIncomingList = (): MessageIncomingListOutput => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.MESSAGE_INCOMING_REDUCER].messageIncomingList
  );
  return data;
};

interface ICountry {
  country_id: number;
  code: string;
  description: string;
  numeric_code: number;
}

export const useGetMemberStateExcludeCyprusCountries = (): Array<ICountry> => {
  const data = useSelector(
    (state: any) =>
      state[ReducerKeys.MESSAGE_INCOMING_REDUCER].memberStateExcludeCyprusList
        .data
  );
  return data;
};
